import { IPlatformServices } from '@wix/native-components-infra/dist/src/types/types';
import { IHttpClient } from '@wix/http-client';
import { getPurchaseRecommendations } from '@wix/ambassador-ecommerce-v1-purchase-recommendation/http';
import type {
  GetPurchaseRecommendationsRequest,
  GetPurchaseRecommendationsResponse,
} from '@wix/ambassador-ecommerce-v1-purchase-recommendation/types';

export class PurchaseRecommendationsService {
  private readonly httpClient: IHttpClient;
  private readonly errorHandler: IPlatformServices['essentials']['errorHandler'];

  constructor({ platformServices }: { platformServices: IPlatformServices }) {
    this.httpClient = platformServices.essentials.httpClient;
    this.errorHandler = platformServices.essentials.errorHandler;
  }

  public async getPurchaseRecommendations(
    request: GetPurchaseRecommendationsRequest,
  ): Promise<GetPurchaseRecommendationsResponse> {
    const { data } = await this.errorHandler.withErrorHandler(
      () => this.httpClient.request(getPurchaseRecommendations(request)),
      { errorCodesMap: {} },
    );
    return data;
  }
}
